// Franchise Selectors
const getFranchiseName = (config, id) => {
    const { franchiseData } = config;
    return franchiseData.find((franchise) => franchise.id === Number(id)).teamCommonName;
};

const getFullNameFromId = (franchises, franchiseId) => {
    if (!franchiseId) {
        return null;
    }

    return franchises.find((franchise) => franchise.id === Number(franchiseId)).fullName;
};

const getFullNameFromCode = (franchises, franchiseCode) => {
    if (!franchiseCode) {
        return null;
    }

    const [category, id] = franchiseCode.split('.');

    return getFullNameFromId(franchises, id);
};

const isFranchiseValidForSeason = (franchise, season) => {
    // If the selected season is before the franchises first season, filter
    const firstSeason = franchise.firstSeason.id;
    if (firstSeason > season) {
        return false;
    }

    // If the selected season is after the franchises last season, filter
    const lastSeason = franchise.lastSeason ? franchise.lastSeason.id : Infinity;
    return !(season > lastSeason);
};

const getFranchisesForSeason = (franchises, season) => {
    return franchises.filter((franchise) => isFranchiseValidForSeason(franchise, season));
};

export default {
    getFranchiseName,
    getFullNameFromId,
    getFullNameFromCode,
    isFranchiseValidForSeason,
    getFranchisesForSeason,
};
